import { axios } from "@/plugins/axios";
import { Plugins, Capacitor } from "@capacitor/core";

async function checkAppVersion() {
    const { Device } = Plugins;
    const info = await Device.getInfo();
    const appVersion = info.appVersion;
    const dataString =
        "version=" + appVersion + "&platform=" + Capacitor.platform;
    return axios.post("?Mode=General&Function=CheckAppVersion", dataString);
}

export { checkAppVersion };
